import React, { useState } from 'react';
import { isVin, vinError } from '../../lib/nhtsa';

// Two ways in: a 17-character VIN, or year/make/model for shoppers who don't have the VIN yet.
export default function VehicleSearch({ onSubmit, loading, compact, error, example = { year: '2019', make: 'Honda', model: 'Odyssey' } }) {
  const [mode, setMode] = useState('vin');
  const [vin, setVin] = useState('');
  const [year, setYear] = useState('');
  const [make, setMake] = useState('');
  const [model, setModel] = useState('');
  const [localError, setLocalError] = useState('');

  const submit = (e) => {
    e && e.preventDefault();
    if (mode === 'vin') {
      const v = vin.trim().toUpperCase();
      if (!isVin(v)) return setLocalError(vinError(v));
      setLocalError('');
      return onSubmit({ vin: v });
    }
    if (!/^(19|20)\d{2}$/.test(year) || !make.trim() || !model.trim()) {
      return setLocalError('Enter a 4-digit year, the make and the model.');
    }
    setLocalError('');
    return onSubmit({ year, make, model });
  };

  const tryExample = () => {
    setMode('model');
    setYear(example.year);
    setMake(example.make);
    setModel(example.model);
    setLocalError('');
    onSubmit(example);
  };

  const shown = localError || error;

  return (
    <form className={`cv-search${compact ? ' cv-search--compact' : ''}`} onSubmit={submit} noValidate>
      <div className="cv-tabs" role="tablist">
        <button type="button" role="tab" className="cv-tab" aria-selected={mode === 'vin'} onClick={() => { setMode('vin'); setLocalError(''); }}>I have the VIN</button>
        <button type="button" role="tab" className="cv-tab" aria-selected={mode === 'model'} onClick={() => { setMode('model'); setLocalError(''); }}>Year / make / model</button>
      </div>

      {mode === 'vin' ? (
        <div className="cv-row">
          <input
            className="cv-input cv-input--vin"
            value={vin}
            onChange={(e) => setVin(e.target.value.toUpperCase().replace(/\s/g, ''))}
            maxLength={17}
            placeholder="17-character VIN"
            spellCheck={false}
            autoComplete="off"
            aria-label="Vehicle identification number"
          />
          <button className="cv-btn" type="submit" disabled={loading}>{loading ? 'Checking…' : 'Check this car'}</button>
        </div>
      ) : (
        <div className="cv-row">
          <input className="cv-input cv-input--year" value={year} onChange={(e) => setYear(e.target.value.replace(/\D/g, '').slice(0, 4))} placeholder="Year" inputMode="numeric" aria-label="Year" />
          <input className="cv-input" value={make} onChange={(e) => setMake(e.target.value)} placeholder="Make (Honda)" aria-label="Make" />
          <input className="cv-input" value={model} onChange={(e) => setModel(e.target.value)} placeholder="Model (Odyssey)" aria-label="Model" />
          <button className="cv-btn" type="submit" disabled={loading}>{loading ? 'Checking…' : 'Check this car'}</button>
        </div>
      )}

      {shown && <div className="cv-error" role="alert">{shown}</div>}

      <div className="cv-search-foot">
        <span>Free · no signup · we never store your VIN</span>
        <button type="button" className="cv-link-btn" onClick={tryExample}>See an example</button>
      </div>
    </form>
  );
}
